import { useUtilityContext } from '@change/core/react/utilityContext';

import { getMediaAssetsBasePath } from '@change-corgi/config/mediaAssets';

export const useMediaAssetsBasePath = (): string => {
	const {
		environment: { getApiEnvironment },
	} = useUtilityContext();
	const environment = getApiEnvironment();
	return getMediaAssetsBasePath(environment !== 'development' ? environment : 'demo');
};
